import request from "@/api";

export function listOrderSale(data) {
    return request({
        url: '/api/order/getOrderSaleList',
        method: 'get',
        params: data
    })
}

export function saveOrderSale(data) {
    return request({
        url: '/api/order/saveOrderSale',
        method: 'post',
        data: data
    })
}

export function saveOrderSaleAmount(data) {
    return request({
        url: '/api/order/saveOrderSaleAmount',
        method: 'post',
        data: data
    })
}


export function deleteOrderSale(data) {
    return request({
        url: '/api/order/deleteOrderSale',
        method: 'post',
        data: data
    })
}

export function deleteBatchOrderSale(data) {
    return request({
        url: '/api/order/deleteBatchOrderSale',
        method: 'post',
        data: data
    })
}


export function batchAddOrderSales(data) {
    return request({
        url: '/api/order/batchAddOrderSales',
        method: 'post',
        data: data
    })
}

export function batchSaveSaleStatus(data) {
    return request({
        url: '/api/order/batchSaveSaleStatus',
        method: 'post',
        data: data
    })
}

export function getOrderSaleCount(data) {
    return request({
        url: '/api/order/getOrderSaleCount',
        method: 'get',
        params: data
    })
}